import React from "react";
import { Form } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { MdDelete, MdModeEditOutline, MdVisibility,MdContentCopy } from "react-icons/md";
import Pagination from "../../../helper/Pagination";

const ItSalesPartnersTable = ({
  partners,
  loading,
  currentPage,
  pagination,
  copiedId,
  setCopiedId,
  searchTerm,
  statusFilter,
  handleSearchChange,
  setStatusFilter,
  handleEditClick,
  removePartner,
  setCurrentPage,
  handleStatusChange,
  handleViewDetails,
  handleTableRowClick,
  handleResendVerification,
}) => {
  return (
    <div className="table-section">
      <div className="d-flex justify-content-between gap-4 align-items-center mb-2">
        <div>
          <button
            className={`me-2 add-btn ${
              statusFilter === "active" ? "active" : ""
            }`}
            onClick={() =>
              setStatusFilter(statusFilter === "active" ? "" : "active")
            }
            style={{
              background:
                statusFilter === "active"
                  ? "linear-gradient(135deg, #1e40af, #3b82f6)"
                  : statusFilter === "inactive"
                  ? "#f8f9fa"
                  : "",
              color:
                statusFilter === "active"
                  ? "white"
                  : statusFilter === "inactive"
                  ? "#666"
                  : "",
            }}
          >
            Active
          </button>
          <button
            className={`add-btn ${statusFilter === "inactive" ? "active" : ""}`}
            onClick={() =>
              setStatusFilter(statusFilter === "inactive" ? "" : "inactive")
            }
            style={{
              background:
                statusFilter === "inactive"
                  ? "linear-gradient(135deg, #1e40af, #3b82f6)"
                  : statusFilter === "active"
                  ? "#f8f9fa"
                  : "",
              color:
                statusFilter === "inactive"
                  ? "white"
                  : statusFilter === "active"
                  ? "#666"
                  : "",
            }}
          >
            Inactive
          </button>
        </div>

        <div className="position-relative">
          <input
            type="search"
            placeholder="Search by Name & Email..."
            className="form-input"
            value={searchTerm}
            onChange={handleSearchChange}
            style={{ width: "200px" }}
          />
          {searchTerm === "" && (
            <div
              className="position-absolute"
              style={{
                top: "50%",
                right: "13px",
                color: "#666",
                transform: "translateY(-50%)",
              }}
            >
              <FaSearch />
            </div>
          )}
        </div>
      </div>

      <div className="table-scroll-wrapper">
        <table className="partners-table">
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Company Name</th>
              <th>Email</th>
              <th>Contact Number</th>
              <th>Country (Currency)</th>
              <th>License Count</th>
              <th>Password</th>
              <th>Stripe License Key ID</th>
              <th>Verification Email</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="12"
                  style={{
                    textAlign: "center",
                    padding: "40px",
                    color: "#666",
                  }}
                >
                  <div className="loading-spinner">
                    <div className="spinner"></div>
                    <p>Loading...</p>
                  </div>
                </td>
              </tr>
            ) : partners.length === 0 ? (
              <tr>
                <td
                  colSpan="12"
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    color: "#666",
                  }}
                >
                  No partners added yet
                </td>
              </tr>
            ) : (
              partners.map((partner, index) => (
                <tr key={partner._id} style={{ cursor: "pointer" }}>
                  <td onClick={() => handleTableRowClick(partner, currentPage, statusFilter)}>
                    {(currentPage - 1) * 10 + index + 1}
                  </td>
                  <td onClick={() => handleTableRowClick(partner, currentPage, statusFilter)}>
                    {partner.companyName || "N/A"}
                  </td>
                  <td onClick={() => handleTableRowClick(partner, currentPage, statusFilter)}>
                    {partner.email || "N/A"}
                  </td>
                  <td onClick={() => handleTableRowClick(partner, currentPage, statusFilter)}>
                    {partner.countryCode && partner.contactNumber
                      ? `(${partner.countryCode}) ${partner.contactNumber}`
                      : partner.contactNumber || "N/A"}
                  </td>
                  <td onClick={() => handleTableRowClick(partner, currentPage, statusFilter)}>
                    {partner.country && partner.currency
                      ? `${partner.country} (${partner.currency})`
                      : partner.country || partner.currency || "N/A"}
                  </td>
                  <td onClick={() => handleTableRowClick(partner, currentPage, statusFilter)}>
                    {typeof partner.licenseCount === "object"
                      ? JSON.stringify(partner.licenseCount)
                      : partner.licenseCount || 0}
                  </td>
                  <td>
                    <div className="password-cell">
                      <span>
                        {partner.plainPassword ? "************" : "N/A"}
                      </span>
                      {partner.plainPassword &&
                        partner.plainPassword !== "N/A" && (
                          <MdContentCopy
                            className="copy-icon"
                            style={{
                              color:
                                copiedId === partner?._id
                                  ? "#28a745"
                                  : "#007bff",
                            }}
                            onClick={() => {
                              const text = partner.plainPassword;

                              // safe clipboard copy
                              if (
                                typeof navigator !== "undefined" &&
                                navigator.clipboard &&
                                window.isSecureContext
                              ) {
                                navigator.clipboard
                                  .writeText(text)
                                  .then(() => {
                                    setCopiedId(partner._id);
                                    setTimeout(() => setCopiedId(null), 2000);
                                  })
                                  .catch(() => {
                                    // fallback
                                    const textArea =
                                      document.createElement("textarea");
                                    textArea.value = text;
                                    textArea.style.position = "fixed";
                                    document.body.appendChild(textArea);
                                    textArea.focus();
                                    textArea.select();
                                    document.execCommand("copy");
                                    document.body.removeChild(textArea);

                                    setCopiedId(partner._id);
                                    setTimeout(() => setCopiedId(null), 2000);
                                  });
                              } else {
                                // fallback always on http
                                const textArea =
                                  document.createElement("textarea");
                                textArea.value = text;
                                textArea.style.position = "fixed";
                                document.body.appendChild(textArea);
                                textArea.focus();
                                textArea.select();
                                document.execCommand("copy");
                                document.body.removeChild(textArea);

                                setCopiedId(partner._id);
                                setTimeout(() => setCopiedId(null), 2000);
                              }
                            }}
                            title={
                              copiedId === partner?._id
                                ? "Copied!"
                                : "Copy password"
                            }
                          />
                        )}
                    </div>
                  </td>
                  <td onClick={() => handleTableRowClick(partner, currentPage, statusFilter)}>
                    {Array.isArray(partner.stripeLicenseKeyId) &&
                    partner.stripeLicenseKeyId.length > 0
                      ? partner.stripeLicenseKeyId
                          .map(
                            (item) =>
                              item.license?.name || item.licenseId || "Unknown"
                          )
                          .join(", ")
                      : partner.stripeLicenseKeyId || "N/A"}
                  </td>
                    <td>
                      {!partner?.verified ? (
                        <button
                          className=""
                          onClick={() => handleResendVerification(partner?._id)}
                          style={{
                            padding: "4px 12px",
                            fontSize: "12px",
                            background: "linear-gradient(135deg, #1e40af, #3b82f6)",
                            border: "none",
                            borderRadius: "4px",
                            color: "white",
                            cursor: "pointer",
                          }}
                        >
                          Resend
                        </button>
                      ) : (
                        <span style={{ color: "#28a745", fontWeight: "bold" }}>Verified</span>
                      )}
                    </td>
                  <td>
                    <Form.Switch
                      className={
                        partner?.status === "active"
                          ? "custom-active info_pointer"
                          : ""
                      }
                      checked={partner?.status === "active"}
                      onChange={() => handleStatusChange(partner)}
                    />
                  </td>
                  <td>
                    <div className="action-buttons">
                      <MdVisibility
                        className="action-icon view-icon"
                        onClick={(e) => {
                          handleViewDetails(partner);
                        }}
                        title="View Details"
                        style={{
                          color: "rgb(102, 102, 102)",
                          cursor: "pointer",
                          marginRight: "8px",
                          fontSize: "13px",
                        }}
                      />
                      <MdModeEditOutline
                        className="action-icon edit-icon"
                        onClick={(e) => {
                          handleEditClick(partner);
                        }}
                        title="Edit Partner"
                        style={{
                          color: "rgb(102, 102, 102)",
                          cursor: "pointer",
                          marginRight: "8px",
                          fontSize: "13px",
                        }}
                      />
                      <MdDelete
                        className="action-icon delete-icon"
                        onClick={(e) => {
                          removePartner(partner);
                        }}
                        title="Delete Partner"
                        style={{
                          color: "rgb(102, 102, 102)",
                          cursor: "pointer",
                          fontSize: "13px",
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={pagination.totalPages}
        totalItems={pagination.totalItems}
        itemsPerPage={pagination.itemsPerPage}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

export default ItSalesPartnersTable;
